import React from 'react';
import './WhatsAppFloat.css';
import whatsappicon from '../../src/assets/contactBlogCareer/whatsapp2-icon.webp'

const WhatsAppFloat = () => {
  return (
    <div className="whatsapp-float">
      <a 
        href="https://wa.me/919134747474" 
        target="_blank" 
        rel="noopener noreferrer"
        className="whatsapp-link"
      >
        <img 
          src={whatsappicon} 
          alt="WhatsApp" 
          className="whatsapp-icon"
        />
      </a>
    </div>
  );
};

export default WhatsAppFloat;
